module.exports = __webpack_public_path__ + "static/media/BackPlay.5cadb4a8.svg";